import { useEffect, useState } from "react";
import axios from "axios";
import "./AdminAjustesCadastrais.css";

export default function AdminAjustesCadastrais() {
    const [solicitacoes, setSolicitacoes] =
        useState([]);

    const [edicoes, setEdicoes] =
        useState({});

    const [loading, setLoading] =
        useState(true);

    useEffect(() => {
        carregarSolicitacoes();
    }, []);

    async function carregarSolicitacoes() {
        try {
            setLoading(true);

            const res = await axios.get(
                "https://app.eliandroalimentos.com.br/api/cliente/listarsolicitacaoajustecadastrocliente"
            );

            setSolicitacoes(res.data);
           // console.log("dados", res.data)
            const novosValores = {};

            res.data.forEach((item) => {
                novosValores[
                    item.DadosCliente.codcliente
                ] = {
                    ...item.Solicitacao,
                };
            });

            setEdicoes(novosValores);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    function alterarCampo(
        codcliente,
        campo,
        valor
    ) {
        setEdicoes((old) => ({
            ...old,
            [codcliente]: {
                ...old[codcliente],
                [campo]: valor,
            },
        }));
    }

   async function aprovar(codcliente) {
    try {
        const body = {
            codcliente,
        };

        Object.entries(edicoes[codcliente]).forEach(
            ([campo, valor]) => {
                if (
                    campo !== "codcliente" &&
                    valor !== null &&
                    valor !== ""
                ) {
                    body[campo] = valor;
                }
            }
        );

        // Se o e-mail foi alterado, envia também o e-mail atual
        if (body.email) {
            body.emailAtual =
                solicitacoes
                    .find(
                        (s) =>
                            s.DadosCliente.codcliente ===
                            codcliente
                    )
                    ?.DadosCliente.Email;
        }

        await axios.put(
            "https://app.eliandroalimentos.com.br/api/cliente/aprovaredicaocliente",
            body
        );

        await axios.delete(
            "https://app.eliandroalimentos.com.br/api/cliente/excluirsolicitacao",
            {
                data: {
                    codcliente,
                },
            }
        );

        await carregarSolicitacoes();
    } catch (err) {
        console.error(err);
        alert(
            "Erro ao aprovar solicitação."
        );
    }
}

    async function excluir(
        codcliente
    ) {
        if (
            !window.confirm(
                "Deseja realmente excluir esta solicitação?"
            )
        ) {
            return;
        }

        try {
            await axios.delete(
                "https://app.eliandroalimentos.com.br/api/cliente/excluirsolicitacao",
                {
                    data: {
                        codcliente,
                    },
                }
            );

            await carregarSolicitacoes();
        } catch (err) {
            console.error(err);
            alert(
                "Erro ao excluir solicitação."
            );
        }
    }

    const campos = [
        {
            titulo: "Nome Fantasia",
            atual: "nomecliente",
            solicitacao: "nomecliente",
        },
        {
            titulo: "Razão Social",
            atual: "razaosocial",
            solicitacao: "razaosocial",
        },
        {
            titulo: "Endereço",
            atual: "Endereco",
            solicitacao: "endereco",
        },
        {
            titulo: "Número",
            atual: "Numero",
            solicitacao: "numero",
        },
        {
            titulo: "Bairro",
            atual: "Bairro",
            solicitacao: "bairro",
        },
        {
            titulo: "Cidade",
            atual: "Cidade",
            solicitacao: "cidade",
        },
        {
            titulo: "Estado",
            atual: "estado",
            solicitacao: "estado",
        },
        {
            titulo: "País",
            atual: "pais",
            solicitacao: "pais",
        },
        {
            titulo: "CEP",
            atual: "cep",
            solicitacao: "cep",
        },
        {
            titulo: "Telefone",
            atual: "fone",
            solicitacao: "fone",
        },
        {
            titulo: "Contato",
            atual: "contato",
            solicitacao: "contato",
        },
        {
            titulo: "Inscrição Estadual",
            atual: "inscestadual",
            solicitacao: "inscestadual",
        },
        {
            titulo: "CNPJ",
            atual: "cgc",
            solicitacao: "cgc",
        },
        {
            titulo: "CPF",
            atual: "cpf",
            solicitacao: "cpf",
        },
        {
            titulo: "Plano",
            atual: "codplano",
            solicitacao: "codplano",
        },
        {
            titulo: "Representante",
            atual: "codrepresentante",
            solicitacao: "codrepresentante",
        },
        {
            titulo: "Email",
            atual: "Email",
            solicitacao: "email",
        },
    ];

    if (loading) {
        return (
            <div className="adminsolicitacoes-loading">
                <div className="adminsolicitacoes-spinner"></div>
                <span>
                    Carregando solicitações...
                </span>
            </div>
        );
    }

    return (
        <div className="adminsolicitacoes-container">

            <h1 className="adminsolicitacoes-title">
                Ajustes Cadastrais
            </h1>

            {solicitacoes.length === 0 ? (

                <div className="adminsolicitacoes-card">
                    Nenhuma solicitação pendente.
                </div>

            ) : (

                solicitacoes.map((item) => (

                    <div
                        className="adminsolicitacoes-card"
                        key={item.DadosCliente.codcliente}
                    >

                        <div className="adminsolicitacoes-cliente">

                            {item.DadosCliente.codcliente}
                            {" - "}
                            {item.DadosCliente.razaosocial}

                        </div>

                        <table className="adminsolicitacoes-table">

                            <thead>

                                <tr>

                                    <th className="adminsolicitacoes-campo">
                                        Campo
                                    </th>

                                    <th className="adminsolicitacoes-atual">
                                        Valor Atual
                                    </th>

                                    <th className="adminsolicitacoes-novo">
                                        Novo Valor
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                {campos
                                    .filter((campo) => {

                                        const valor =
                                            item.Solicitacao[
                                            campo.solicitacao
                                            ];

                                        return (
                                            valor !== null &&
                                            valor !== "" &&
                                            valor !== undefined
                                        );

                                    })
                                    .map((campo) => (

                                        <tr
                                            key={campo.solicitacao}
                                        >

                                            <td className="adminsolicitacoes-campo">
                                                {campo.titulo}
                                            </td>

                                            <td className="adminsolicitacoes-atual">

                                                <div className="adminsolicitacoes-atual-box">

                                                    <label className="adminsolicitacoes-checkbox">

                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                (edicoes[item.DadosCliente.codcliente]?.[
                                                                    campo.solicitacao
                                                                ] ?? "") ===
                                                                (item.DadosCliente[campo.atual] ?? "")
                                                            }
                                                            onChange={(e) =>
                                                                alterarCampo(
                                                                    item.DadosCliente.codcliente,
                                                                    campo.solicitacao,
                                                                    e.target.checked
                                                                        ? item.DadosCliente[campo.atual] ?? ""
                                                                        : item.Solicitacao[campo.solicitacao] ?? ""
                                                                )
                                                            }
                                                        />

                                                    </label>

                                                    <span>
                                                        {item.DadosCliente[campo.atual] ?? "-"}
                                                    </span>

                                                </div>

                                            </td>

                                            <td className="adminsolicitacoes-novo">

                                                <input
                                                    className="adminsolicitacoes-input"
                                                    value={
                                                        edicoes[
                                                        item.DadosCliente.codcliente
                                                        ]?.[
                                                        campo.solicitacao
                                                        ] ?? ""
                                                    }
                                                    onChange={(e) =>
                                                        alterarCampo(
                                                            item.DadosCliente.codcliente,
                                                            campo.solicitacao,
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                            </td>

                                        </tr>

                                    ))}

                            </tbody>

                        </table>

                        <div className="adminsolicitacoes-acoes">

                            <button
                                className="adminsolicitacoes-btn aprovar"
                                onClick={() =>
                                    aprovar(
                                        item.DadosCliente.codcliente
                                    )
                                }
                            >
                                Aprovar
                            </button>

                            <button
                                className="adminsolicitacoes-btn rejeitar"
                                onClick={() =>
                                    excluir(
                                        item.DadosCliente.codcliente
                                    )
                                }
                            >
                                Excluir
                            </button>

                        </div>

                    </div>

                ))

            )}

        </div>
    );
}